<template>
  <section class="banners" v-if="page.banners">
    <div class="inner">
      <div class="cycle-slideshow">
        <div :key="banner._id" class="slide" v-for="banner in page.banners">
          <img :src="banner.image" alt>
          <page-link :to="banner.url ? '/' + banner.url : ''" class="caption">
            {{banner.caption}}
            <span v-if="banner.link_text">
              <i class="fa fa-chevron-circle-right"></i>
              {{banner.link_text}}
            </span>
          </page-link>
        </div>
        <div class="banner-pager"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Banners",
  computed: {
    page: function() {
      return this.$store.state.page
    }
  }
}
</script>

<style scoped>
.cycle-slideshow {
  position: relative;
  background: #434f50;
}

.banners {
  margin: 3rem 0;
}

.banners img {
  width: 100%;
}

.slide {
  display: none;
}

.slide:first-child {
  display: block;
}

.slide {
  position: relative;
}

.caption {
  position: absolute;
  bottom: 10%;
  left: 0%;
  z-index: 999;
  color: white;
  font-size: 3rem;
  padding: 1rem 4rem;
  background: #434f50;
}

.caption span {
  display: block;
  font-size: 1.5rem;
  color: #f79227;
}

.banner-pager {
  color: white;
  font-size: 3rem;
  position: absolute;
  z-index: 999;
  bottom: 7%;
  right: 4rem;
}

.banner-pager span {
  opacity: 0.5;
  cursor: pointer;
}

.banner-pager span.cycle-pager-active {
  opacity: 1;
}

@media screen and (max-width: 650px) {
  .banners {
    padding-top:2rem;
    margin: 1rem 0;
  }
  .cycle-slideshow {    
    padding-bottom: 2.5rem;
  }
  .banner-pager {
    right: 0;
    width:100%;
    text-align:center;
    bottom:0;
  }
  .caption {
    position: relative;
    bottom: auto;
    left: 0%;
    width: 100%;
    top: -0.5rem;
    font-size: 1.8rem;
    padding: 1rem 2rem;
    display: block;
    text-align: center;
  }
}
</style>
